'use client'

import { useEffect } from 'react'
import Clarity from '@microsoft/clarity'

export default function ClarityProvider() {
  useEffect(() => {
    Clarity.init('w5i1838dn0')
  }, [])

  return null
}
